import React from "react";
import { Instagram, Youtube, Mail, ArrowUpRight } from "lucide-react";

const LINKS = [
    { label: "About", id: "mission" },
    { label: "Participate", id: "participate" },
    { label: "Contact", id: "newsletter" },
];

export const Footer = () => {
    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <footer
            data-testid="site-footer"
            className="relative bg-tip-black text-white pt-24 md:pt-32 pb-10"
        >
            <div className="tip-container">
                <div className="grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-7">
                        <img
                            data-testid="footer-logo"
                            src="https://customer-assets.emergentagent.com/job_debate-hub-44/artifacts/jej58rjv_LOGO5.png"
                            alt="The India Projekt"
                            className="w-full max-w-[520px] h-auto"
                            style={{ filter: "invert(1)" }}
                        />
                        <p className="mt-8 max-w-md text-white/65">
                            A new-age Indian media platform built around free
                            speech, creative content and entertainment.
                        </p>
                    </div>

                    <div className="lg:col-span-5 grid sm:grid-cols-2 gap-10">
                        <div>
                            <div className="eyebrow text-white/50 mb-5">
                                Sitemap
                            </div>
                            <ul className="space-y-3">
                                {LINKS.map((l) => (
                                    <li key={l.id}>
                                        <button
                                            data-testid={`footer-link-${l.id}`}
                                            onClick={() => scrollTo(l.id)}
                                            className="font-display text-xl font-bold link-underline"
                                        >
                                            {l.label}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <div className="eyebrow text-white/50 mb-5">
                                Connect
                            </div>
                            <ul className="space-y-4">
                                <li>
                                    <a
                                        data-testid="footer-instagram"
                                        href="https://instagram.com/the.india.projekt"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="inline-flex items-center gap-2 link-underline"
                                    >
                                        <Instagram size={18} />
                                        @the.india.projekt
                                    </a>
                                </li>
                                <li>
                                    <a
                                        data-testid="footer-youtube"
                                        href="https://youtube.com/@the.india.projekt"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="inline-flex items-center gap-2 link-underline"
                                    >
                                        <Youtube size={18} />
                                        YouTube
                                    </a>
                                </li>
                                <li>
                                    <a
                                        data-testid="footer-email"
                                        href="mailto:info@theindiaprojekt.com"
                                        className="inline-flex items-center gap-2 link-underline"
                                    >
                                        <Mail size={18} />
                                        info@theindiaprojekt.com
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* India flag bar */}
                <div className="mt-20 grid grid-cols-3 h-2">
                    <div style={{ background: "var(--tip-saffron)" }} />
                    <div className="bg-white" />
                    <div style={{ background: "var(--tip-green)" }} />
                </div>

                <div className="mt-10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-white/50 text-xs tracking-[0.18em] uppercase">
                    <span>© {new Date().getFullYear()} The India Projekt</span>
                    <span className="flex items-center gap-2">
                        Made in India <ArrowUpRight size={14} />
                    </span>
                </div>
            </div>
        </footer>
    );
};
